import React from 'react';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import LoadingButton from '@mui/lab/LoadingButton';
import {
    TextField,
    Link,
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

import Box from 'elements/Box';
import { ProjectConfig } from 'Global';

export default function FormForgotPass( props: any ) {
    
    const {
        setState,
        email,
        setEmail,
    } = props;

    /*================================================
    SNACKBAR FUNCTION FOR NOTIFICATIONS
    ================================================*/
    const { enqueueSnackbar } = useSnackbar();
    /*============================================= */

    const [loading, setLoading] = React.useState(false);

    /*================================================
    FORGOT PASSWORD (SUBMIT)
    ================================================*/
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        setLoading(true);
        axios
        .get(ProjectConfig.api_url+"/users/password_recovery", {
            params: {
                email: data.get('email'),
            },
        })
        .then((response) => {
            if(response.data.status === "success"){
                enqueueSnackbar(response.data.message, { variant: 'success' });
                setState('credentialsSent');
            } else {
                enqueueSnackbar(response.data.message, { variant: 'error' });
            }
        })
        .catch((error) => {
            enqueueSnackbar(error.toString(), { variant: 'error' });
        })
        .finally(() => {
            setLoading(false);
        });
        
    };
    /*================================================
    ================================================*/

    return(
        <Box id='loginBox' className='intent-auth_component'>

          <Link
            component="button"
            variant="subtitle2"
            underline="none"
            onClick={() => {
                setEmail('');
                setState('login')
            }}
            sx={{display:'flex', alignItems:'center', fontSize: 'small', justifyContent: 'start', columnGap: '5px', padding: '0px 0px 10px 0px'}}
          >
            <ArrowBack sx={{ fontSize: 'small' }} />
            Back
          </Link>
          
          <form onSubmit={handleSubmit} className='form'>
            <TextField
              required
              fullWidth
              id="email"
              label="Email"
              name="email"
              type="text"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <LoadingButton
              size="small"
              type="submit"
              loading={loading}
              fullWidth
              variant="contained"
              sx={{ fontSize: '13px', padding: '10px 0px'}}
            >
              Send
            </LoadingButton>

          </form>
        </Box>
    );
}